module.exports = __webpack_public_path__ + "img/knue_main0.fb4d5494.jpg";